import { __, includes } from 'lodash/fp';

import { AuthorizationState } from '@mews/framework';

import { fetchPaymentCards } from '../../../api/actions/paymentCards';
import { authorizePaymentCard } from '../../../api/actions/paymentCardsAuthorizations';
import { isPaymentCardAuthorizable } from './selectors';

const isPaymentCardAuthorizationPossible = includes(__, [AuthorizationState.Requested, AuthorizationState.Pending]);

const isPaymentCardAuthorizationRequired =
    ({ enterpriseId, paymentCardId }: $TSFixMe) =>
    async (dispatch: $TSFixMe, getState: $TSFixMe) => {
        await dispatch(fetchPaymentCards({ paymentCardIds: [paymentCardId] }));

        const isAuthorizable = isPaymentCardAuthorizable(getState(), { paymentCardId });
        if (isAuthorizable) {
            const { state } = await dispatch(authorizePaymentCard({ enterpriseId, paymentCardId }));

            return isPaymentCardAuthorizationPossible(state);
        }

        return false;
    };

export const shouldAuthorizePaymentCard =
    ({ enterpriseId, paymentCardId }: $TSFixMe) =>
    async (dispatch: $TSFixMe, _getState: $TSFixMe, { loggerService }: $TSFixMe) => {
        try {
            return await dispatch(isPaymentCardAuthorizationRequired({ enterpriseId, paymentCardId }));
        } catch (error) {
            loggerService.log(
                'is-card-authorization-required-check-error',
                'Is card authorization required check failed.',
                { error, extra: { enterpriseId, paymentCardId } }
            );

            return false;
        }
    };
